module.exports = __webpack_public_path__ + "media/10.94a30806.mp3";